import { Modal, Stack } from 'ui';

import { FundraisingDescriptionForm } from '../../../molecules';
import { SetupPeerPageModalFooter } from './SetupPeerPageModalFooter';
import {
  ModalTitleWithBackButton,
  useSetupPeerPageModalProvider,
} from './SetupPeerPageModalProvider';
import { SetupPeerPageStepper } from './SetupPeerPageStepper';

const SetupFundraisingDescriptionModal = () => {
  const { opened, closeAllModals, meta } = useSetupPeerPageModalProvider({
    id: 'description',
  });

  return (
    <Modal
      opened={opened}
      onClose={closeAllModals}
      title={<ModalTitleWithBackButton>Fundraising Description</ModalTitleWithBackButton>}
    >
      <Stack gap="lg">
        <SetupPeerPageStepper activeStep={1} />
        <FundraisingDescriptionForm initialValue={meta.peer.description} />
      </Stack>

      <SetupPeerPageModalFooter />
    </Modal>
  );
};

export { SetupFundraisingDescriptionModal };
